export default "__VITE_ASSET__8hbYE9b8__"